export const QUERY_PARAM_APP = {
  bfm: "bfm",
  dxf: "dxf",
  invoice: "invoice",
  loan: "loan",
} as const;

export const QUERY_PARAM_FROM = {
  registerCompany: "register-company",
} as const;
